// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__suO4B","toggle":"styles_toggle__38J1J","preview":"styles_preview__1S72t"};